export default __webpack_public_path__ + "static/media/bike-storage.4aed0525.svg";